import { paths } from '../routing/path';
import { BuyerOppMarketplaceTab } from '../slices/marketplace/timeline/models/enums/buyer-opportunity-details-tab.enum';
import { MarketplaceCommsHubTab } from '../containers/AdminMarketplace/MarketplaceTabs/MarketplaceCommsHub/MarketplaceCommsHubTabs';

/**
 * The buyer's Comms Hub → Meetings of an opportunity. While an admin is viewing as a buyer the
 * path stays inside the view-as route (see `paths.venues.connect.opportunities`).
 */
export const getBuyerEngagementMeetingsPath = (engagementId: number): string =>
    `${paths.venues.connect.opportunities}?opportunityId=${engagementId}&tab=${BuyerOppMarketplaceTab.CommsHub}&subtab=${MarketplaceCommsHubTab.Meetings}`;
